import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 's18-start-order',
  templateUrl: './start-order.component.html',
  styleUrls: ['./start-order.component.scss']
})
export class StartOrderComponent implements OnInit {
  @Input() startOrder: number;

  constructor() { }

  ngOnInit() {
  }

  getStartOrder(){
    switch (this.startOrder){
      case 1:
        return 'A';
      case 2:
        return 'B';
      case 3:
        return 'C';
    }
  }

}
